import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Seo from "../components/Seo";
import { Building2, MapPin, Gauge } from "lucide-react";

export default function Institutions() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/institutions").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-10 md:py-14" data-testid="institutions-page">
      <Seo
        title="Arbitration institutions"
        description="Tracked arbitration institutions, courts and law firms — ICC, ICSID, UNCITRAL, SIAC, LCIA, HKIAC, MCIA, Bar & Bench, LiveLaw and more. Live updates and institutional background."
        path="/institutions"
      />
      <div className="eyebrow">Institution Watch</div>
      <h1 className="font-serif text-[44px] md:text-[56px] mt-2 text-[var(--io-text)]">Arbitration institutions</h1>
      <p className="mt-3 text-[15px] text-[var(--io-text-2)] max-w-2xl">
        Tracked institutions, courts and law firms we monitor daily. Each page aggregates live updates and institutional background.
      </p>

      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((ins) => (
          <Link key={ins.slug} to={`/institution/${ins.slug}`} className="io-card p-5 group flex flex-col" data-testid={`institution-${ins.slug}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="w-9 h-9 rounded-md border border-[var(--io-gold)]/30 bg-gradient-to-br from-[var(--io-gold)]/10 to-transparent flex items-center justify-center">
                  <Building2 size={16} className="text-[var(--io-gold)]" />
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--io-muted)]">{ins.source_type}</span>
              </div>
              <span className="io-badge">
                <Gauge size={10}/> {ins.reliability}/10
              </span>
            </div>

            <h3 className="font-serif text-[20px] mt-3 text-[var(--io-text)] group-hover:text-[var(--io-gold)] leading-snug">{ins.name}</h3>
            <div className="mt-1.5 flex items-center gap-1 text-[11px] font-mono text-[var(--io-text-2)]"><MapPin size={11}/> {ins.region}</div>
            {ins.topics?.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1.5">
                {ins.topics.slice(0, 3).map((t) => <span key={t} className="io-badge">{t}</span>)}
              </div>
            )}
            <div className="mt-4 pt-3 border-t border-[var(--io-border)] flex items-center justify-between text-[11px] font-mono">
              <span className="text-[var(--io-text-2)]">{ins.article_count} article{ins.article_count !== 1 ? "s" : ""}</span>
              <span className="text-[var(--io-gold)] group-hover:underline">Open profile →</span>
            </div>
          </Link>
        ))}
        {items.length === 0 && <div className="text-[var(--io-muted)] col-span-full py-12 text-center">Loading institutions…</div>}
      </div>
    </div>
  );
}
